import { renderAvailabilities } from "../availabilities/src";

const container = document.querySelector('.availabilities-carousel');
const slider = container.querySelector('.slider > .items');
const popupElm = container.querySelector('dialog');

/*
renderAvailabilities(popupElm, slider, {
  items: 1,
  nav: false,
  autoplay: false,
  loop: false,
  controlsPosition: 'bottom',
  autoHeight: true
}, false, false);
*/
